<template>
  <el-dialog :title="$t('1380')" append-to-body :visible.sync="visible" :close-on-click-modal="false" width="648px">
    <div class="dialog-body">
      <!-- steps -->
      <el-steps :active="active" finish-status="success">
        <el-step :title="$t('1384')"></el-step>
        <el-step :title="$t('1388')"></el-step>
      </el-steps>
      <!-- 每个周期天书 -->
      <template v-if="active === 0">
        <p class="count-days">
          {{ $t('1739') }}
          <el-tooltip effect="dark" :content="this.$t('1732')" placement="top-start">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <el-input-number v-model="form.num" @change="handleChange" :min="2" :max="31"></el-input-number>
        </p>
        <el-form ref="form" :model="form" label-width="80px">
          <!-- 周期天数循环 -->
          <el-form-item v-for="(item, index) in form.num" :key="index" :label="$t('1737', { n: index + 1 })">
            <!-- 已选班次循环 -->
            <el-select v-model="form.shift_ids[index]" :placeholder="$t('221')">
              <el-option v-for="(v, i) in scheduling" :key="i" :label="v.name" :value="v.shift_id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template v-else>
        <el-table border @selection-change="handlerSelection" ref="table" :data="tableData">
          <el-table-column type="selection" width="65"></el-table-column>
          <el-table-column prop="format_name">
            <template slot="header">
              {{ $t('1389') }}
              <el-tooltip class="item" effect="dark" :content="$t('1740')" placement="top-start">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <!-- 确认取消 -->
    <span slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="confirm" :loading="loading">{{ active ? $t('131') : $t('331') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { round_edit_cycle, round_sel_cycle_group } from 'api/Attendance'
export default {
  data() {
    return {
      visible: false, // 组件展示
      form: {
        id: '', // 考勤组ID
        num: 2, // 当前周期天数
        shift_ids: [], // 班次
        cycle_id: '', // 周期iD
        group_ids: [] // 选中的周期分组序号（1-31
      },
      tableData: [], // 表格数据
      scheduling: [], // 班次选项
      active: 0, // step
      loading: false
    }
  },
  methods: {
    init(params, data, setting) {
      this.active = 0
      this.visible = true
      // 下啦选项循环
      this.scheduling = params || []
      this.form.id = setting.groupId
      this.form.cycle_id = setting.cycleId
      // data存在则数据回显
      if (data) {
        this.form.num = data.length
        this.form.shift_ids = data.map(item => item.id)
      }
    },
    // 删除多余的选项
    handleChange() {
      this.$nextTick(() => this.form.shift_ids.splice(this.form.num))
    },
    handlerSelection(arr) {
      this.form.group_ids = arr.map(item => item.group_id)
    },
    confirm() {
      this.loading = true
      // active 0 下一步 1保存
      if (!this.active) {
        return round_edit_cycle(this.form)
          .then(res => {
            this.active = 1
            this.tableData = res.data

            this.form.cycle_id = res.data[0].cycle_id
          })
          .finally(() => (this.loading = false))
      }
      round_sel_cycle_group(this.form)
        .then(() => {
          this.visible = false
          this.$emit('update')
          this.loading = false
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.count-days {
  margin: 20px 0;
}
.el-icon-question {
  display: inline-block;
  margin-right: 10px;
}
.dialog-body {
  max-height: 400px;
  overflow: auto;
  padding: 0 10px;
  /deep/ .el-steps {
    max-width: 80%;
    margin: 0 auto;
  }
}
/deep/ .el-form {
  padding-left: 33px;
}
/deep/ .el-table {
  margin-top: 15px;
}
</style>
